import { createContext } from "react";
import { AppMeta } from "@xnav/types/src/common"

export const AppContext = createContext<AppMeta>({} as AppMeta)
